import { render, staticRenderFns } from "./SwitchSelector.vue?vue&type=template&id=3eadae5a&scoped=true"
import script from "./SwitchSelector.vue?vue&type=script&lang=js"
export * from "./SwitchSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eadae5a",
  null
  
)

export default component.exports